import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getAttachmentTypes() {
    var url = "/Checklist/GetAttachmentTypes";
    return this.http.get(url).toPromise();
  }

  getItemGroups(checklistTemplateID?: number) {
    var url = "/Checklist/GetItemGroups?checklistTemplateID=" + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  getChecklistTemplates(checklistTemplateCatgID?: number) {
    let url = "/Checklist/GetChecklistTemplates?checklistTemplateCatgID=" + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  toggleTemplateActive(checklistTemplateID: number, isActive: boolean) {
    return this.http.post("/Checklist/ToggleTemplateActive",
      {
        checklistTemplateID: checklistTemplateID,
        isActive: isActive
      }).toPromise();
  }

  addUpdateTemplate(requestObj: any) {
    return this.http.post("/Checklist/AddUpdateTemplate",
      {
        checklistTemplateID: requestObj.checklistTemplateID,
        checklistTemplateCatgID: requestObj.checklistTemplateCatgID,
        checklistTemplateName: requestObj.checklistTemplateName,
        userGroupID: requestObj.userGroupID,
        reportRDLFileName: requestObj.reportRDLFileName,
        checklistTextHeader: requestObj.checklistTextHeader,
        workflowInclPM: requestObj.workflowInclPM,
        workflowInclJobRev: requestObj.workflowInclJobRev,
        workflowInclInvRev: requestObj.workflowInclInvRev,
        workflowInclUserGroupID: requestObj.workflowInclUserGroupID,
        workflowInclTimecardManager: requestObj.workflowInclTimecardManager,
        enableWorkflow: requestObj.enableWorkflow,
        adminGroupID: requestObj.adminGroupID,
        disableSubmission: requestObj.disableSubmission,
        attachmentType: requestObj.attachmentType,
        rdlData: requestObj.rdlData,
        attachDocumentFlagValue: requestObj.attachDocumentFlagValue,
        workflowUsersCanFinalize: requestObj.WorkflowUsersCanFinalize,
      }).toPromise();
  }

  copyChecklistTemplate(origChecklistTemplateID: number, newChecklistTemplateName: string) {
    return this.http.post("/Checklist/CopyChecklistTemplate",
      {
        origChecklistTemplateID: origChecklistTemplateID,
        newChecklistTemplateName: newChecklistTemplateName
      }).toPromise();
  }

  templateItemToggleActive(checklistTemplateItemID: number, isActive: boolean) {
    return this.http.post("/Checklist/TemplateItemToggleActive",
      {
        checklistTemplateItemID: checklistTemplateItemID,
        isActive: isActive
      }).toPromise();
  }

  addUpdateTemplateItem(requestObj: any) {
    return this.http.post("/Checklist/AddUpdateTemplateItem",
      {
        checklistTemplateItemID: requestObj.checklistTemplateItemID,
        checklistTemplateItemGrpID: requestObj.checklistTemplateItemGrpID,
        responseTypeID: requestObj.responseTypeID,
        itemPrompt: requestObj.itemPrompt,
        itemNumber: requestObj.itemNumber,
        itemLongPrompt: requestObj.itemLongPrompt,
        checklistLookupID: requestObj.checklistLookupID,
        maxResponseLength: requestObj.maxResponseLength,
        validationRegex: requestObj.validationRegex,
        personalInfoField: requestObj.personalInfoField,
        isAdminField: requestObj.isAdminField,
        isRequiredAttachment: requestObj.isRequiredAttachment,
        rebindDropdown: requestObj.rebindDropdown,
        showComments: requestObj.showComments,
        showAttachments: requestObj.showAttachments,
        isRequired: requestObj.isRequired
      }).toPromise();
  }

  getItem(checklistInstanceID) {
    var url = "/Checklist/GetItem?checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getItemsByTemplateID(templateId: number) {
    let url = "/Checklist/GetItemsByTemplateID?checklistTemplateID=" + templateId;
    return this.http.get(url).toPromise();
  }

  getLookupDataTypes() {
    var url = "/Checklist/GetLookupDataTypes";
    return this.http.get(url).toPromise();
  }

  getTemplateInfo(checklistTemplateID: number) {
    var url = "/Checklist/GetTemplateInfo?checklistTemplateID=" + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  getTemplateInfoFromInstance(checklistInstanceID: number) {
    var url = "/Checklist/GetTemplateInfoFromInstance?checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getHeaderFieldsByTemplateID(checklistTemplateID: number) {
    var url = "/Checklist/GetHeaderFieldsByTemplateID?checklistTemplateID=" + checklistTemplateID;
    return this.http.get(url).toPromise();
  }

  insertUpdateHeaderFields(requestObj: any) {
    return this.http.post("/Checklist/InsertUpdateHeaderFields",
      {
        checklistHeaderFieldID: requestObj.checklistHeaderFieldID,
        checklistTemplateID: requestObj.checklistTemplateID,
        headerFieldName: requestObj.headerFieldName,
        headerFieldLabel: requestObj.headerFieldLabel,
        fieldType: requestObj.fieldType,
        fieldIsRequired: requestObj.fieldIsRequired,
        isRestrictedAccess: requestObj.isRestrictedAccess,
        isActive: requestObj.isActive
      }).toPromise();

  }

  addItemGroups(checklistTemplateID: number, itemGroupName: string, itemGroupSeq?: number, itemGroupPct?: number) {
    return this.http.post("/Checklist/AddItemGroups",
      {
        checklistTemplateID: checklistTemplateID,
        itemGroupName: itemGroupName,
        itemGroupSeq: itemGroupSeq,
        itemGroupPct: itemGroupPct
      }).toPromise();
  }

  editItemGroups(checklistTemplateID: number, itemGroupName: string, itemGroupSeq?: number, itemGroupPct?: number) {
    return this.http.post("/Checklist/EditItemGroups",
      {
        checklistTemplateID: checklistTemplateID,
        itemGroupName: itemGroupName,
        itemGroupSeq: itemGroupSeq,
        itemGroupPct: itemGroupPct
      }).toPromise();
  }

  moveChecklistGroup(direction?: number, checklistTemplateItemGrpID?: number) {
    return this.http.post("/Checklist/MoveChecklistGroup",
      {
        direction: direction,
        checklistTemplateItemGrpID: checklistTemplateItemGrpID
      }).toPromise();
  }

  submitChecklistOrder(direction?: number, checklistInstanceID?: number) {
    return this.http.post("/Checklist/SubmitChecklistOrder",
      {
        direction: direction,
        checklistInstanceID: checklistInstanceID
      }).toPromise();
  }

  deleteItemGroup(checklistTemplateItemGrpID: number) {
    return this.http.post("/Checklist/DeleteItemGroup",
      {
        checklistTemplateItemGrpID: checklistTemplateItemGrpID
      }).toPromise();
  }

  getTemplateCategories(checklistTemplateCatgID?: number) {
    var url = "/Checklist/GetTemplateCategories?checklistTemplateCatgID=" + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  getBranches() {
    var url = "/Checklist/GetBranches";
    return this.http.get(url).toPromise();
  }

  getChecklistHistory(formData: any, checklistTemplateCatgID?: number) {
    var url = "/Checklist/GetChecklistHistory?branchID=" + formData.selectedBranch + "&fromDateString=" + moment(formData.fromDate.getTime()).format("YYYY-MM-DD") + "&toDateString=" + moment(formData.toDate.getTime()).format("YYYY-MM-DD") + "&checklistTemplateCatgID=" + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  saveMultiChecklists(checklistInstanceIDs: number[], filenames: string[], templateID: number[], isonboard?: string) {
    return this.http.post("/Checklist/SaveMultiChecklists",
      {
        checklistInstanceIDs: checklistInstanceIDs,
        filenames: filenames,
        templateID: templateID,
        isonboard: isonboard
      }).toPromise();
  }

  downloadMultiChecklists(filenameList: string[], zipName: string) {
    var url = "/Checklist/DownloadMultiChecklists?name=" + (filenameList.length > 1 ? zipName : filenameList[0] + ".pdf");
    return this.http.get(url).toPromise();
  }


  getChecklistReviewers(checklistInstanceID: number) {
    return this.http.get("/Checklist/GetChecklistReviewers?checklistInstanceID=" + checklistInstanceID).toPromise();
  }

  initializeChecklistReviewers(checklistInstanceID: number) {
    return this.http.post("/Checklist/InitializeChecklistReviewers",
      {
        checklistInstanceID: checklistInstanceID
      }).toPromise();
  }

  deleteChecklistReviewers(checklistRevID: number) {
    return this.http.post("/Checklist/DeleteChecklistReviewers",
      {
        checklistRevID: checklistRevID
      }).toPromise();
  }

  addChecklistReviewer(userKeyID: number, checklistInstanceID: any, reviewerSource: string) {
    return this.http.post("/Checklist/AddChecklistReviewer",
      {
        userKeyID: userKeyID,
        checklistInstanceID: checklistInstanceID,
        reviewerSource: reviewerSource
      }).toPromise();
  }

  sendChecklists(checklistInstanceIDs: number[], filenames: string[], fromEmail: string, toEmail: string[], subject: string, message: string, newFilenames: string[], newFiles: any[], templateID: any[], mailFrom: string, queueType: string, notificationMode: string, sMSTo: string, checklistTemplateCatgID: number) {
    return this.http.post("/Checklist/SendChecklists",
      {
        checklistInstanceIDs: checklistInstanceIDs,
        filenames: filenames,
        fromEmail: fromEmail,
        toEmail: toEmail,
        subject: subject,
        message: message,
        newFilenames: newFilenames,
        newFiles: newFiles,
        templateID: templateID,
        mailFrom: mailFrom,
        queueType: queueType,
        notificationMode: notificationMode,
        sMSTo: sMSTo,
        checklistTemplateCatgID: checklistTemplateCatgID
      }).toPromise();
  }

  sendChecklistSign(signatureDataStr: string, checklistInstanceID: number, typeSign: boolean, latitude: number, longitude: number, pdfFileData: string = null, pdfFileName: string = null) {
    return this.http.post("/Checklist/sendChecklistSign",
      {
        signatureDataStr: signatureDataStr,
        checklistInstanceID: checklistInstanceID,
        typeSign: typeSign,
        latitude: latitude,
        longitude: longitude,
        pdfFileData: pdfFileData,
        pdfFileName: pdfFileName
      }).toPromise();
  }

  getChecklistInstanceDetails(checklistInstanceID: number) {
    var url = "/Checklist/GetChecklistInstanceDetails?checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getInfoByOnboardID() {
    var url = "/Hiring/GetInfoByOnboardID";
    return this.http.get(url).toPromise();
  }

  getHeaderFields(checklistInstanceID: number) {
    var url = "/Checklist/GetHeaderFields?checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }

  getChoicesByHeaderFieldID(checklistHeaderFieldID: number, checklistInstanceID: number, pRCO?: number) {
    var url = "/Checklist/GetChoicesByHeaderFieldID?checklistHeaderFieldID=" + checklistHeaderFieldID + "&checklistInstanceID=" + checklistInstanceID + "&pRCO=" + pRCO;
    return this.http.get(url).toPromise();
  }

  updateHeaderFieldValue(checklistInstanceID: number, checklistHeaderFieldID: number, fieldValue: string, fieldType: string) {
    return this.http.post("/Checklist/UpdateHeaderFieldValue",
      {
        checklistInstanceID: checklistInstanceID,
        checklistHeaderFieldID: checklistHeaderFieldID,
        fieldValue: fieldValue,
        fieldType: fieldType
      }).toPromise();
  }

  submitChecklist(checklistInstanceID: number, pdfData: string = null, pdfFileName: string = null) {
    return this.http.post("/Checklist/SubmitChecklist",
      {
        checklistInstanceID: checklistInstanceID,
        pdfData: pdfData,
        pdfFileName: pdfFileName
      }).toPromise();
  }

  deleteChecklistItem(checklistInstanceID: number, templateCategoryID: number) {
    return this.http.post("/Checklist/DeleteChecklistItem",
      {
        checklistInstanceID: checklistInstanceID,
        templateCategoryID: templateCategoryID
      }).toPromise();
  }

  createNewChecklist(checklistTemplateID: number) {
    return this.http.post("/Checklist/CreateNewChecklist",
      {
        checklistTemplateID: checklistTemplateID
      }).toPromise();
  }

  getTypeSign(type: string, name: string = null) {
    let url = "/Checklist/GetTypeSign?type=" + type;
    if (name != null)
      url += "&name=" + name;
    return this.http.get(url).toPromise();
  }

  sendChecklistsToVista(checklistInstanceID: number, checklistTemplateID: number, attachDocumentFlagValue: number, createdBy: number, attachmentType: number, fileName?: string) {
    return this.http.post("/Checklist/SendChecklistsToVista",
      {
        checklistInstanceID: checklistInstanceID,
        checklistTemplateID: checklistTemplateID,
        attachDocumentFlagValue: attachDocumentFlagValue,
        createdBy: createdBy,
        attachmentType: attachmentType,
        fileName: fileName
      }).toPromise();
  }

  getLookup() {
    var url = "/Checklist/GetLookup";
    return this.http.get(url).toPromise();
  }

  GetLookupChoices(checklistLookupID: number) {
    var url = "/Checklist/GetLookupChoices?checklistLookupID=" + checklistLookupID;
    return this.http.get(url).toPromise();
  }

  updateLookupChoices(checklistHeaderChoiceID: number, checklistLookupID: number, choiceShortName: string, choiceLongName: string, choiceIsActive: boolean, isValueNotUnique: boolean) {
    return this.http.post("/Checklist/UpdateLookupChoices",
      {
        checklistHeaderChoiceID: checklistHeaderChoiceID,
        checklistLookupID: checklistLookupID,
        choiceShortName: choiceShortName,
        choiceLongName: choiceLongName,
        choiceIsActive: choiceIsActive,
        isValueNotUnique: isValueNotUnique
      }).toPromise();
  };

  deleteLookupChoices(checklistHeaderChoiceID: number, checklistLookupID: number) {
    return this.http.post("/Checklist/DeleteLookupChoices",
      {
        checklistHeaderChoiceID: checklistHeaderChoiceID,
        checklistLookupID: checklistLookupID
      }).toPromise();
  };

  moveSeqLookupChoices(direction: number, checklistHeaderChoiceID: number) {
    return this.http.post("/Checklist/MoveSeqLookupChoices",
      {
        direction: direction,
        checklistHeaderChoiceID: checklistHeaderChoiceID
      }).toPromise();
  };

  updateLookup(checklistLookupID: number, checklistLookupName: string, checklistLookupSQLOverride: string, checklistLookupIsActive: boolean) {
    return this.http.post("/Checklist/UpdateLookup",
      {
        checklistLookupID: checklistLookupID,
        checklistLookupName: checklistLookupName,
        checklistLookupSQLOverride: checklistLookupSQLOverride,
        checklistLookupIsActive: checklistLookupIsActive
      }).toPromise();
  };

  evaluateLookup(checklistLookupID: number, includeInactive: boolean) {
    var url = "/Checklist/EvaluateLookup?checklistLookupID=" + checklistLookupID + "&includeInactive=" + includeInactive;
    return this.http.get(url).toPromise();
  }

  updateItem(checklistInstanceItemID: any, itemComments: any, itemResponse: any, itemIsCorrected: any, correctedComments: any, signatureDataStr: any, typeSign: any, typeID: any, latitude: any,
    longitude: any, itemResponseDisplay: any) {
    return this.http.post("/Checklist/UpdateItem",
      {
        checklistInstanceItemID: checklistInstanceItemID, itemComments: itemComments, itemResponse: itemResponse, itemIsCorrected: itemIsCorrected, correctedComments: correctedComments,
        signatureDataStr: signatureDataStr, typeSign: typeSign, typeID: typeID, latitude: latitude, longitude: longitude, itemResponseDisplay: itemResponseDisplay
      }).toPromise();
  }

  getChoicesByTemplateItemID(checklistTemplateItemID: any, checklistInstanceID: any) {
    var url = "/CheckList/GetChoicesByTemplateItemID?checklistTemplateItemID=" + checklistTemplateItemID + "&checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }
  getChecklistInstancePDF(checklistInstanceID: number) {
    var url = "/Checklist/GetChecklistInstancePDF?checklistInstanceID=" + checklistInstanceID;
    return this.http.get(url).toPromise();
  }
}
